import { PageTitle } from "@/components/site/PageTitle";
import { TIPOLOGIE } from "@/lib/data";
import { ListingGrid } from "@/pages/Listings";
import { SearchForm } from "@/components/site/SearchForm";

const T = (slug) => TIPOLOGIE.find((t) => t.slug === slug);

const Testo = ({ t }) => (
  <div className="mb-10">
    <img src={t.img} alt={t.nome} className="w-full h-auto mb-6" />
    <p className="leading-7">{t.intro}</p>
    {t.punti.length > 0 && (
      <ul className="mt-3 list-disc pl-6 leading-7">
        {t.punti.map((p) => <li key={p}>{p}</li>)}
      </ul>
    )}
  </div>
);

export const IVAffitti = () => {
  const t = T("ivaffitti");
  return (
    <div data-testid="servizio-page-ivaffitti">
      <PageTitle title="IVAffitti" crumbs={[{ label: "IVAffitti" }]} />
      <div className="max-w-[1240px] mx-auto px-4 pt-8 grid grid-cols-1 lg:grid-cols-[290px_1fr] gap-8">
        <aside>
          <h2 className="font-tit font-bold text-[var(--iv)] uppercase text-xl mb-3">Cerca in affitto</h2>
          <SearchForm initial={{ contratto: "Affitto" }} vertical />
        </aside>
        <ListingGrid params={{ contratto: "Affitto" }} intro={<Testo t={t} />} />
      </div>
    </div>
  );
};

const Page = ({ slug }) => {
  const t = T(slug);
  return (
    <div data-testid={`servizio-page-${slug}`}>
      <PageTitle title={t.nome} crumbs={[{ label: t.nome }]} />
      <div className="max-w-[1240px] mx-auto px-4 pt-10">
        <div className="max-w-[920px]">
          <Testo t={t} />
          {slug === "ivcall" && <img src="/img/ivcall_logo.jpg" alt="IVCall" className="w-[260px] h-auto" />}
        </div>
      </div>
    </div>
  );
};

export const IVServizi = () => <Page slug="ivservizi" />;
export const IVCall = () => <Page slug="ivcall" />;
